import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Button, Checkbox, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { toast } from "react-toastify";
import { MDBCol } from "mdbreact";
import { MODELOS_INTEGRATION } from "../../utils";

@observer
export default class SCI extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: {}) {
    super(props);
  }

  async handleSaveToken() {

    if (!IntegrationStore.obs.selectedEmpresa.cnpj) {
      toast.warning('Você precisa selecionar uma empresa.', {});
      return
    }

    if (!Object.values(IntegrationStore.obs.modelos_integration_sci).some(Boolean)) {
      toast.warning('Você precisa selecionar pelo menos um Modelos de Importação.', {});
      return
    }

    let data = {
      token: IntegrationStore.obs.token_cliente_sci,
      cnpj: IntegrationStore.obs.selectedEmpresa.cnpj,
      envio_automatico: IntegrationStore.obs.envio_automatico_sci_api,
      tipo: "sci",
      modelos_integration_sci: IntegrationStore.obs.modelos_integration_sci
    }

    await IntegrationStore.handleSaveToken(data)

  }

  handleChangeEnvio = (e) => {

    const newValue = e.target.checked;

    IntegrationStore.obs.envio_automatico_sci_api = newValue

  };

  render() {
    return (
      <>

        <div style={{ background: "#f5f8fa", borderLeft: "3px solid #2b82bc", padding: "10px 14px", borderRadius: 4, marginTop: 15, marginBottom: 15 }}>
          <p style={{ margin: 0, fontSize: 11, color: "#394b59", lineHeight: 1.6 }}>
            <strong>SCI:</strong> integração realizada via API através do módulo{" "}
            <strong>Integra NET</strong> contratado.
          </p>
        </div>

        <FormGroup label="Envio Automático">
          <Switch
            label={IntegrationStore.obs.envio_automatico_sci_api ? "Ativado" : "Desativado"}
            checked={IntegrationStore.obs.envio_automatico_sci_api}
            onChange={(e: any) => this.handleChangeEnvio(e)} />
        </FormGroup>

        {IntegrationStore.obs.envio_automatico_sci_api && (<>
          <FormGroup label="Modelos de Importação" labelInfo="*">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(100px, 1fr))", gap: 15, width: "max-content" }}>
              {MODELOS_INTEGRATION.map((item) => (
                <Checkbox
                  key={item.id}
                  disabled={["nfse_tomador", "nfse_prestador"].includes(item.id)}
                  type="checkbox"
                  label={item.name}
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    width: "max-content",
                    maxWidth: "100%",
                  }}
                  checked={!!IntegrationStore.obs.modelos_integration_sci[item.id]}
                  onChange={(e: any) => {
                    IntegrationStore.obs.modelos_integration_sci = {...IntegrationStore.obs.modelos_integration_sci, [item.id]: e.target.checked};
                  }}
                />
              ))}
            </div>
          </FormGroup>
        </>)}

        <FormGroup
          label="Token de Acesso SCI"
          labelInfo="*"
          helperText={
            <>
              Token de Acesso deve ser do tipo: <strong>"contabilidade"</strong> (gerado pelo acesso admin do SCI WEB).
              Para mais detalhes de como gerá-lo, acesse a seção <strong>4. Autenticação</strong> na documentação:&nbsp;
              <a
                href="https://documenter.getpostman.com/view/31312760/2sAYBVgBZr#13fd55a3-ee88-4fc8-9699-a05034c7cf5e"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline", color: "#137CBD" }}
              >
                Documentação SCI
              </a>
            </>
          }
        >
          <InputGroup
            style={{ width: 500 }}
            value={IntegrationStore.obs.token_cliente_sci}
            onChange={(e: any) => IntegrationStore.obs.token_cliente_sci = e.target.value}
          />
        </FormGroup>

        <Button intent="primary" onClick={() => this.handleSaveToken()}>Salvar configuração</Button>

      </>
    )
  }


}